import { schema } from "normalizr";

export const orderTablesSchema = new schema.Entity("orderTables", {});

export const orderTablesListSchema = [orderTablesSchema];
